import { useEffect, useRef, useState } from 'react';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HtmlParser from 'react-html-parser';

import styles from './AccordionOption/AccordionOption.module.scss';
import jsStyles from './AccordionOption/styles';

const CustomAccordion = withStyles(jsStyles.accordion)(Accordion);
const CustomAccordionSummary = withStyles(jsStyles.summary)(AccordionSummary);
const CustomAccordionDetails = withStyles(jsStyles.details)(AccordionDetails);

const regexp = (str) => RegExp(str, 'gi');
const boldString = (str, substr) =>
  substr ? str.replace(regexp(substr), `<b>$&</b>`) : str;

function AccordionWithSearch({
  placeholder,
  onClick,
  data,
  selected,
  alwaysExpanded = false,
  small = false,
}) {
  const [isExpanded, setIsExpanded] = useState(alwaysExpanded);
  const [inputValue, setInputValue] = useState(selected?.text || '');
  const inputRef = useRef(null);
  const handleSelectedItem = (item) => {
    if (!alwaysExpanded) {
      setIsExpanded(false);
    }
    onClick(item);
  };

  const handleAccordionChange = () => {
    if (alwaysExpanded || !isExpanded) {
      setInputValue('');
      inputRef.current.focus();
    }

    if (!alwaysExpanded) {
      setIsExpanded((prev) => !prev);
    }
  };

  useEffect(() => setInputValue(selected?.text || ''), [selected]);

  const options = data.filter((item) => {
    if (item.text.match(regexp(inputValue))) {
      return true;
    }

    if (item.subText && item.subText.match(regexp(inputValue))) {
      return true;
    }

    return false;
  });

  return (
    <div style={jsStyles.container}>
      <CustomAccordion
        id="accordion"
        onChange={handleAccordionChange}
        expanded={isExpanded}
        TransitionProps={{
          onExited: () => setInputValue(selected?.text || ''),
        }}
      >
        <CustomAccordionSummary
          expandIcon={
            alwaysExpanded ? null : (
              <ExpandMoreIcon style={{ fill: 'var(--color-main-orange)' }} />
            )
          }
        >
          <div className={styles.option__container}>
            <input
              className={styles.input}
              placeholder={placeholder}
              ref={inputRef}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              type="text"
            />
          </div>
        </CustomAccordionSummary>
        <CustomAccordionDetails>
          <div
            style={{
              maxHeight: alwaysExpanded ? 'none' : undefined,
              marginBottom: alwaysExpanded ? '20px' : undefined,
            }}
            className={
              small ? styles.listContainer_small : styles.listContainer
            }
          >
            {options.map((item) => (
              <div
                key={item.value}
                className={styles.option__container}
                onClick={() => handleSelectedItem(item)}
              >
                <div className={styles.option__text}>
                  {HtmlParser(boldString(item.text, inputValue))}
                  {item.subText && (
                    <div style={{ fontSize: 14 }}>
                      {HtmlParser(boldString(item.subText, inputValue))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </CustomAccordionDetails>
      </CustomAccordion>
    </div>
  );
}

export default AccordionWithSearch;
